<template>
  <div class="map-legend" :class="{lite}">
    <div v-if="config.scaleOption === 'gradient'" class="legend-wrapper">
      <div class="color-wrapp" :style="'background:' + cssGradient(config.colorRange)" />
      <div class="labels-wrapper">
        <span>{{ formatValue(mapDataLimits.min) }}</span>
        <span>{{ formatValue(mapDataLimits.max) }}</span>
      </div>
    </div>
    <div v-else-if="config.scaleOption === 'steps'" class="legend-wrapper">
      <div class="colors-wrapper">
        <div v-for="(step,i) in legendSteps" :key="i" class="color-wrapper">
          <div class="color-box" :style="'backgroundColor: ' + getColor(step.min)" />
          <span v-if="i<legendSteps.length-1" class="threshold">{{ formatValue(step.max) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { extent as d3_extent } from 'd3-array'
import { cssGradient, colorScaleFromConfig } from '../../utils/colorUtils'
import { maskValue } from '@/utils/formatUtils'
import { format as d3_format } from 'd3-format'

export default {
  props: ['config', 'allTimeValues', 'dataCard','lite'],
  computed: {
    mapDataLimits() {
      let extent = d3_extent(this.allTimeValues, d => d)
      let min = extent[0]
      let max = extent[1]
      return {
        min: min,
        max: max,
      }
    },
    colorScale() {
      return colorScaleFromConfig(this.config, this.allTimeValues)
    },

    legendSteps() {
      // let linearScale = d3_scaleLinear().range(this.mapConfig.colorRange)
      //
      // let ticks = d3_range(0,1,1/this.mapConfig.scaleSteps)
      // let ticks = this.colorScale.range()
      // let colors = ticks.map((t)=>linearScale(t))
      let colors = this.colorScale.range()

      let items = colors.map(c => {
        let extent = this.colorScale.invertExtent(c)
        return {
          min: extent[0] || this.mapDataLimits.min,
          max: extent[1] || this.mapDataLimits.max,
        }
      })
      return items
    },
  },
  methods: {
    cssGradient,
    getColor(d) {
      return this.colorScale(d)
    },
    formatValue(value) {
      if (this.config.scaleOption === 'steps') {
        if (this.dataCard.mask?.indexOf('%') >= 0) return d3_format('.0%')(value / 100)
        else return d3_format('.2s')(value)
      } else {
        return maskValue(value, this.dataCard)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.legend-wrapper
  display: flex
  flex-direction: column
  margin-right: vw(10px)
  max-width: "calc(100% - %s)" % vw(40px)
  width: vw(300px)
    
  
  .lite &, .mobile &
    width vw(160px)
    margin-top: vw(0px)
    margin-right: 0
    background rgba(255,255,255,0.85)
    padding 4px
    min-height vw(32px)
    border-radius vw(2px)
    // width: 100%
    

  .colors-wrapper
    display: flex
    width: 100%
    gap: vw(10px)
    .lite &
      gap vw(4px)

    .color-wrapper
      position: relative
      display: flex
      flex: 1
      flex-direction: column

      .color-box
        height: vw(25px)
        .lite &
          height vw(8px)

      .threshold
        position: absolute
        top: 100%
        m-font-size(14, 20)
        left: 100%
        color: $more-grays
        text-align: center
        transform: "translate(calc(-50% + %s), 0)" % vw(5px)
        // transform: translate(vw(-10px), 0)

  .color-wrapp
    width: 100%
    height: vw(25px)
    .lite &
      height vw(10px)

  .labels-wrapper
    display: flex
    justify-content: space-between
    width: 100%

    span
      m-font-size(14, 20)
      color: $more-grays
</style>
